<form [formGroup]="apiConfigurationEventForm" class="form">
    <div class="form-container" [ngClass]="{ readonly: apiConfigurationState.$mode() === FormMode.Reading }">
        <div class="form-item">
            <mat-form-field>
                <mat-label>Nom</mat-label>
                <input matInput type="text" formControlName="name" autocomplete="off" tabindex="1" />
            </mat-form-field>
        </div>
        <div class="form-item">
            <mat-form-field>
                <mat-label>Description</mat-label>
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" formControlName="description" autocomplete="off" tabindex="2"></textarea>
            </mat-form-field>
        </div>
        <div class="form-table">
            <mat-form-field>
                <mat-label>Conditions</mat-label>
                <app-conditions-form
                    formControlName="conditions"
                    [responseVariables]="apiConfigurationState.$apiConfiguration().responseConfiguration.responseVariableConfigurations" />
            </mat-form-field>
        </div>
        <div class="form-table">
            <mat-form-field>
                <mat-label>Actions</mat-label>
                <app-actions-form formControlName="actions" [responseVariables]="apiConfigurationState.$apiConfiguration().responseConfiguration.responseVariableConfigurations" />
            </mat-form-field>
        </div>
    </div>
</form>
<div class="wizard-step-buttons">
    <button mat-raised-button (click)="onCancelClick()">Annuler</button>
    @if (apiConfigurationState.$mode() !== FormMode.Reading) {
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="apiConfigurationEventForm.invalid"
            [ngClass]="{ disabled: apiConfigurationEventForm.invalid }"
            (click)="onSaveClick()">
            Enregistrer
        </button>
    }
</div>
